// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,400,700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Projects section */
.projects {
  height: auto;
}

.projects-container {
  overflow-y: hidden;
  overflow-x: hidden;
}

.title-heading {
  color: white;
  font-size: 4rem;
  text-transform: uppercase;
  padding: 4rem;
  letter-spacing: 0.3rem;
  text-align: center;
}

.project-container {
  color: white;
  text-transform: uppercase;
  display: flex;
  flex-wrap: wrap;
}

.projects-container .project {
  position: relative;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.projects-container .project .content {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 85%;
  border-radius: 15px;
  transition: all 0.5s;
  cursor: auto;
  overflow: hidden;
}

.content:hover {
  transform: translate(0, -10px);
}

.content:before {
  content: "";
  display: block;
  padding-top: 10%;
}

.projects-container .project .content img {
  display: block;
  margin: 0 auto;
  width: 31%;
}

.name {
  color: white;
  margin: 10px 0;
  font-size: 4rem;
  margin-bottom: -0.5rem;
}

.description {
  color: white;
  font-size: 2rem;
  padding: 0rem 1rem;
  margin-bottom: 1.5rem;
}

.card {
  float: left;
  padding: 1rem;
}
.card .menu-content {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.card .menu-content::before, .card .menu-content::after {
  content: "";
  display: table;
}
.card .menu-content::after {
  clear: both;
}
.card .menu-content li {
  display: inline-block;
}
.card .menu-content a {
  color: #fff;
}
.card .wrapper {
  min-height: 540px;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.2);
}
.card .wrapper:hover .data {
  transform: translateY(0);
}
.card .data {
  position: absolute;
  bottom: 0;
  width: 100%;
  transform: translateY(calc(80px + 1em));
  transition: transform 0.3s;
}
.card .data .content {
  padding: 1.5em;
  position: relative;
  z-index: 1;
}
.card .type {
  font-size: 12px;
}
.card .title {
  text-align: left;
  margin-top: 10px;
}
.card .text {
  height: 70px;
  margin: 0;
  font-size: 2.5rem;
}
.card input[type=checkbox] {
  display: none;
}
.card input[type=checkbox]:checked + .menu-content {
  transform: translateY(-60px);
}

.example-2 .wrapper {
  background: url(https://images.unsplash.com/photo-1547405358-4ef2671bb1bb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80) 30% 1%/cover no-repeat;
}
.example-2 .date {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #333;
  color: #fff;
  padding: 0.7em 2.5em 1.5rem 0.7em;
  border-radius: 0 0 90% 0;
}
.example-2 .date span {
  display: block;
  text-align: center;
}
.example-2 .date .day {
  font-weight: 700;
  font-size: 24px;
  text-shadow: 2px 3px 2px rgba(0, 0, 0, 0.18);
}
.example-2 .date .month {
  text-transform: uppercase;
}
.example-2 .date .month,
.example-2 .date .year {
  font-size: 10px;
}
.example-2 .content {
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  box-shadow: 0 5px 30px 10px rgba(0, 0, 0, 0.3);
}
.example-2 .title a {
  color: white;
}

.alternate-card {
  float: left;
  padding: 1rem;
  min-width: 500px;
}
.alternate-card .menu-content {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.alternate-card .menu-content::before, .alternate-card .menu-content::after {
  content: "";
  display: table;
}
.alternate-card .menu-content::after {
  clear: both;
}
.alternate-card .menu-content li {
  display: inline-block;
}
.alternate-card .menu-content a {
  color: #fff;
}
.alternate-card .wrapper {
  min-height: 540px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.2);
}
.alternate-card .wrapper:hover .data {
  transform: translateY(0);
}
.alternate-card .data {
  position: absolute;
  bottom: 0;
  width: 100%;
  transform: translateY(calc(100% + 1em));
  transition: transform 0.3s;
}
.alternate-card .data .content {
  padding: 1.5em;
  position: relative;
  z-index: 1;
}
.alternate-card .type {
  font-size: 12px;
}
.alternate-card .title {
  margin-top: 10px;
}
.alternate-card .text {
  height: 325px;
  margin: 0;
}
.alternate-card input[type=checkbox] {
  display: none;
}
.alternate-card input[type=checkbox]:checked + .menu-content {
  transform: translateY(-60px);
}`, "",{"version":3,"sources":["webpack://./src/components/Projects.scss"],"names":[],"mappings":"AAAA,qBAAA;AACA;EACE,YAAA;AAEF;;AACA;EACE,kBAAA;EACA,kBAAA;AAEF;;AACA;EACE,YAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAEF;;AACA;EACE,YAAA;EACA,yBAAA;EACA,aAAA;EACA,eAAA;AAEF;;AACA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;AAEF;;AACA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;AAEF;;AACA;EACE,8BAAA;AAEF;;AACA;EACE,WAAA;EACA,cAAA;EACA,gBAAA;AAEF;;AACA;EACE,cAAA;EACA,cAAA;EACA,UAAA;AAEF;;AACA;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;AAEF;;AACA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;AAEF;;AA0BA;EACE,WAAA;EACA,aAAA;AAvBF;AAwBE;EAEE,SAAA;EACA,UAAA;EACA,qBAAA;AAvBJ;AAKE;EAEE,WAAA;EACA,cAAA;AAJJ;AAME;EACE,WAAA;AAJJ;AAiBI;EACE,qBAAA;AAfN;AAiBI;EACE,WA9BE;AAeR;AAkBE;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0EAAA;AAhBJ;AAkBM;EACE,wBAAA;AAhBR;AAoBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,uCAAA;EACA,0BAAA;AAlBJ;AAmBI;EACE,cAAA;EACA,kBAAA;EACA,UAAA;AAjBN;AAoBE;EACE,eAAA;AAlBJ;AAoBE;EACE,gBAAA;EACA,gBAAA;AAlBJ;AAoBE;EACE,YAAA;EACA,SAAA;EACA,iBAAA;AAlBJ;AAoBE;EACE,aAAA;AAlBJ;AAoBE;EACE,4BAAA;AAlBJ;;AAwBE;EACE,0KAAA;AArBJ;AAuBE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,WAvFI;EAwFJ,iCAAA;EACA,wBAAA;AArBJ;AAsBI;EACE,cAAA;EACA,kBAAA;AApBN;AAsBI;EACE,gBAAA;EACA,eAAA;EACA,4CAAA;AApBN;AAsBI;EACE,yBAAA;AApBN;AAsBI;;EAEE,eAAA;AApBN;AAuBE;EACE,oCAAA;EACA,YAAA;EACA,8CAAA;AArBJ;AAwBI;EACE,YAAA;AAtBN;;AA6BA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AA1BF;AA2BE;EAEE,SAAA;EACA,UAAA;EACA,qBAAA;AA1BJ;AAhGE;EAEE,WAAA;EACA,cAAA;AAiGJ;AA/FE;EACE,WAAA;AAiGJ;AAoBI;EACE,qBAAA;AAlBN;AAoBI;EACE,WAtIE;AAoHR;AAqBE;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0EAAA;AAnBJ;AAqBM;EACE,wBAAA;AAnBR;AAuBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,uCAAA;EACA,0BAAA;AArBJ;AAsBI;EACE,cAAA;EACA,kBAAA;EACA,UAAA;AApBN;AAuBE;EACE,eAAA;AArBJ;AAuBE;EACE,gBAAA;AArBJ;AAuBE;EACE,aAAA;EACA,SAAA;AArBJ;AAuBE;EACE,aAAA;AArBJ;AAuBE;EACE,4BAAA;AArBJ","sourcesContent":["/* Projects section */\n.projects {\n  height: auto;\n}\n\n.projects-container {\n  overflow-y:hidden;\n  overflow-x: hidden;\n}\n\n.title-heading {\n  color: white;\n  font-size: 4rem;\n  text-transform: uppercase;\n  padding: 4rem;\n  letter-spacing: .3rem;\n  text-align: center;\n}\n\n.project-container {\n  color: white;\n  text-transform: uppercase;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.projects-container .project {\n  position: relative;\n  border-radius: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n.projects-container .project .content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 85%;\n  border-radius: 15px;\n  transition: all 0.5s;\n  cursor: auto;\n  overflow: hidden;\n}\n\n.content:hover {\n  transform: translate(0, -10px);\n}\n\n.content:before {\n  content: \"\";\n  display: block;\n  padding-top: 10%;\n}\n\n.projects-container .project .content img {\n  display: block;\n  margin: 0 auto;\n  width: 31%;\n}\n\n.name {\n  color: white;\n  margin: 10px 0;\n  font-size: 4rem;\n  margin-bottom: -0.5rem;\n}\n\n.description {\n  color: white;\n  font-size: 2rem;\n  padding: 0rem 1rem;\n  margin-bottom: 1.5rem;\n}\n\n\n@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,400,700);\n\n\n// Variables\n$dark-blue: #1E1B2D;\n$light-blue: #828092;\n$white: #fff;\n$black: #000;\n$open-sans: 'Open Sans',\nsans-serif;\n\n// clear-fix mixin\n@mixin cf {\n  &::before,\n  &::after {\n    content: '';\n    display: table;\n  }\n  &::after {\n    clear: both;\n  }\n}\n\n// Base styles\n.card {\n  float: left;\n  padding: 1rem;\n  .menu-content {\n    @include cf;\n    margin: 0;\n    padding: 0;\n    list-style-type: none;\n    li {\n      display: inline-block;\n    }\n    a {\n      color: $white;\n    }\n  }\n  .wrapper {\n    min-height: 540px;\n    border-radius: 20px;\n    position: relative;\n    overflow: hidden;\n    box-shadow: 0 19px 38px rgba($black, 0.3), 0 15px 12px rgba($black, 0.2);\n    &:hover {\n      .data {\n        transform: translateY(0);\n      }\n    }\n  }\n  .data {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    transform: translateY(calc(80px + 1em));\n    transition: transform 0.3s;\n    .content {\n      padding: 1.5em;\n      position: relative;\n      z-index: 1;\n    }\n  }\n  .type {\n    font-size: 12px;\n  }\n  .title {\n    text-align: left;\n    margin-top: 10px;\n  }\n  .text {\n    height: 70px;\n    margin: 0;\n    font-size: 2.5rem;\n  }\n  input[type='checkbox'] {\n    display: none;\n  }\n  input[type='checkbox']:checked + .menu-content {\n    transform: translateY(-60px);\n  }\n}\n\n\n.example-2 {\n  .wrapper {\n    background: url(https://images.unsplash.com/photo-1547405358-4ef2671bb1bb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80) 30% 1% / cover no-repeat;\n  }\n  .date {\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: #333;\n    color: $white;\n    padding: .7em 2.5em 1.5rem .7em;\n    border-radius: 0 0 90% 0;\n    span {\n      display: block;\n      text-align: center;\n    }\n    .day {\n      font-weight: 700;\n      font-size: 24px;\n      text-shadow: 2px 3px 2px rgba($black, 0.18);\n    }\n    .month {\n      text-transform: uppercase;\n    }\n    .month,\n    .year {\n      font-size: 10px;\n    }\n  }\n  .content {\n    background-color: rgba(0,0,0,0.5);\n    color: white;\n    box-shadow: 0 5px 30px 10px rgba($black, 0.3);\n  }\n  .title {\n    a {\n      color: white;\n    }\n  }\n}\n\n\n// Base styles\n.alternate-card {\n  float: left;\n  padding: 1rem;\n  min-width: 500px;\n  .menu-content {\n    @include cf;\n    margin: 0;\n    padding: 0;\n    list-style-type: none;\n    li {\n      display: inline-block;\n    }\n    a {\n      color: $white;\n    }\n  }\n  .wrapper {\n    min-height: 540px;\n    position: relative;\n    overflow: hidden;\n    box-shadow: 0 19px 38px rgba($black, 0.3), 0 15px 12px rgba($black, 0.2);\n    &:hover {\n      .data {\n        transform: translateY(0);\n      }\n    }\n  }\n  .data {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    transform: translateY(calc(100% + 1em));\n    transition: transform 0.3s;\n    .content {\n      padding: 1.5em;\n      position: relative;\n      z-index: 1;\n    }\n  }\n  .type {\n    font-size: 12px;\n  }\n  .title {\n    margin-top: 10px;\n  }\n  .text {\n    height: 325px;\n    margin: 0;\n  }\n  input[type='checkbox'] {\n    display: none;\n  }\n  input[type='checkbox']:checked + .menu-content {\n    transform: translateY(-60px);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
